export const ActionTypes = {
  GET_TOUR_DETAILS: "GET_TOUR_DETAILS",
  CLEAR_TOURS: "CLEAR_TOURS",
  GET_TOUR_SEAL_DETAILS: "GET_TOUR_SEAL_DETAILS",
  CLEAR_TOUR_SEAL_DETAILS: "CLEAR_TOUR_SEAL_DETAILS",
  GET_RIDER_DETAILS: "GET_RIDER_DETAILS",
  CLEAR_RIDER_DETAILS: "CLEAR_RIDER_DETAILS",

  //loader
  SET_LOADER: "SET_LOADER",
  UNSET_LOADER: "UNSET_LOADER",

  //Team
  TEAMS_FETCH: "TEAMS_FETCH",
  //Homebase
  SINGLE_HOMEBASE_FETCH: "SINGLE_HOMEBASE_FETCH",
  HOMEBASES_FETCH: "HOMEBASES_FETCH",

};
